import { render } from "./set_shop_withdrawal.vue?vue&type=template&id=22d643f5&ts=true"
import script from "./set_shop_withdrawal.vue?vue&type=script&lang=ts"
export * from "./set_shop_withdrawal.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__